import { Avatar } from 'antd';
import Utils from '@/utils/utils';
import ResizeWrapper from '@/components/ResizeWrapper';
import styles from './index.module.less';
import stylesConversation from '../View/Conversation/index.module.less';
import { NavBar } from 'antd-mobile';
import React, { useEffect, useState } from 'react';
import { post } from '@/utils/request';
import {useNavigate} from "react-router-dom";

export default function() {


  /**
   * 初始化会话
   */
  const [conversationId, setConversationId] = useState<any>();
  const [messageList, setMessageList] = useState<any>([]);
  const getConversation = (conversationId: any) => {
    //日期列表
    post('/cbc/history/message/list', {
      conversationId: conversationId,
    }).then((res) => {
      let data = res.data;
      setMessageList(data);
    });
  };

  useEffect(() => {
    const conversationId = Utils.getUrlArgs()?.conversationId;
    setConversationId(conversationId);
    getConversation(conversationId);
  }, []);

  return (
    <ResizeWrapper className={styles.container}>

      <NavBar
        className={styles.navBar}
        style={{ height: 65 }}
        children={<div className={styles.navBarTitle}>原始对话</div>}
        onBack={() => {
          history.back();
        }}
      />

      {/*对话*/}
      <div className={styles.messageContainer}>
        <div className={stylesConversation.wrapper} style={{padding: '20px 10px 100px 10px',height: 'auto'}}>
          <div className={stylesConversation.conversation}>
            {messageList?.map((item:any, index:any) => {
              const isUserMsg = item.userId !== 'RTCBotTest';
              const isRobotMsg = item.userId === 'RTCBotTest';
              // 对话内容
              return (
                <div
                  className={`${stylesConversation.sentence} ${isUserMsg ? stylesConversation.userContainer : stylesConversation.robotContainer}`}
                  key={`msg-${index}`}>

                  {/*头像*/}
                  {
                    isUserMsg && <>
                      <div className={stylesConversation.userMsg}>
                        <span>{item.content}</span>
                      </div>
                      <div style={{ width: 50, marginLeft: 10, marginTop:12 }}>
                        <Avatar src={require('@/assets/img/avatarUser.png')} style={{ width: 40,height: 40 }} />
                      </div>
                    </>
                  }
                  {
                    isRobotMsg && <>
                      <div style={{ width: 50 }}>
                        <Avatar src={require('@/assets/img/user_cyber.png')} style={{ width: 40,height: 40 }} />
                      </div>
                      <div className={stylesConversation.robotMsg}>
                        <span>{item.content}</span>
                      </div>
                    </>
                  }
                </div>

              );
            })}
          </div>
        </div>
      </div>

    </ResizeWrapper>
  );
}
